import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getBlogPosts } from '../api';
import BlogPostCard from '../components/shared/BlogPostCard';

export default function BlogPage() {
  const [posts, setPosts] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const category = searchParams.get('category');

  useEffect(() => {
    getBlogPosts(category).then(setPosts).catch(() => {});
  }, [category]);

  const categories = [...new Set(posts.map(p => p.category).filter(Boolean))];

  return (
    <div className="pt-28 pb-20">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Blog</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Strategies, lessons, and insights from building revenue-driving digital products.
          </p>
        </div>

        {categories.length > 0 && (
          <div className="flex flex-wrap gap-2 justify-center mb-10">
            <button
              onClick={() => setSearchParams({})}
              className={`px-4 py-2 rounded-full text-sm font-medium transition ${!category ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}
            >
              All
            </button>
            {categories.map(c => (
              <button key={c}
                onClick={() => setSearchParams({ category: c })}
                className={`px-4 py-2 rounded-full text-sm font-medium transition ${category === c ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}
              >
                {c}
              </button>
            ))}
          </div>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {posts.map(p => <BlogPostCard key={p.id} post={p} />)}
        </div>
        {posts.length === 0 && (
          <p className="text-center text-gray-500 py-12">No blog posts published yet. Check back soon!</p>
        )}
      </div>
    </div>
  );
}
